module.exports = __webpack_public_path__ + "static/img/nav_logo.17d02a49.png";